import { Component, OnInit, OnDestroy } from "@angular/core";
import { ActivatedRoute, Router, NavigationEnd, NavigationStart } from "@angular/router";
import { CclDrawerService, CclMessageService, CclNotifyService, CclPopupService } from "certain-common-library";
import { SharedService } from "./modules/shared/services/shared.service";
import { AccountService } from "./modules/shared/services/account.service";
import { EventService } from "./modules/shared/services/event.service";
import { CatalogService } from "./modules/shared/services/catalog.service";
import { LocalDataService } from "./modules/shared/services/local-data.service";
import { CookieService } from "ngx-cookie";
import { AttendeeSessionService } from "./modules/shared/services/attendee-session.service";
import { v4 as uuid } from "uuid";
import { Observable, Subscription } from "rxjs";
import { DomSanitizer } from "@angular/platform-browser";
import { FlashMessagesService } from "angular2-flash-messages";
import { HttpClient } from "@angular/common/http";

@Component({
    selector: "app-root",
    templateUrl: "./app.component.html",
    styleUrls: ["./app.component.scss"],
    providers: [AccountService, EventService, CatalogService]
})
export class AppComponent implements OnInit, OnDestroy {
    title = "app";
    loaded: boolean = false;
    catalogErrorMessage: string = null;

    private subscription: Subscription;
    private initSubscription: Subscription;

    constructor(
        private router: Router,
        private popupService: CclPopupService,
        public sharedService: SharedService,
        private accountService: AccountService,
        private messageService: CclMessageService,
        private eventService: EventService,
        private catalogService: CatalogService,
        private cookieService: CookieService,
        private attendeeSessionService: AttendeeSessionService,
        public sanitizer: DomSanitizer,
        private _flashMessagesService: FlashMessagesService,
        private notifyService: CclNotifyService,
        private localDataService: LocalDataService,
        private httpClient: HttpClient
    ) {
        this.subscription = this.router.events.subscribe((event) => {
            if (event instanceof NavigationStart) {
                if (!this.router.navigated) {
                    if (event.url.includes("(")) {
                        this.sharedService.navigateHelper(event.url.split("(")[0]);
                    }
                }
                if (event.url.split("/")[2] && event.url.split("/")[2] != sessionStorage.getItem('catalogUUID')) {
                    sessionStorage.removeItem("eventUUID");
                    sessionStorage.removeItem("catalogUUID");
                }
            }
        });
        this.initSubscription = this.messageService.getMessage().subscribe((message) => this.init(message));

        if (sharedService.getParameterByName("catalogUUID").length > 0) {
            sharedService.catalogUUID = sharedService.getParameterByName("catalogUUID");

            let redirectTo = sharedService.getParameterByName("redirectTo");

            if (sharedService.isEmptyString(redirectTo)) {
                redirectTo = "admin";
            }

            this.sharedService.navigateHelper(redirectTo + "/" + sharedService.catalogUUID);
        }
    }

    ngOnDestroy() {
        this.sharedService.unsubscribeHelper(this.initSubscription);
        this.sharedService.unsubscribeHelper(this.subscription);
    }

    init(message) {

        this.redirectToScalingCatalogIfFlagEnabled();
        if (message.text == "initialize-app") {
            if(!this.cookieService.get("XSRF-TOKEN")) {
                let csrfToken = uuid();
                this.cookieService.put("XSRF-TOKEN", csrfToken);
            }

            this.sharedService.regUUID = this.sharedService.getParameterByName("rgUUID");

            this.sharedService.loginPopup = this.sharedService.getParameterByName("loginPopup");

            sessionStorage.setItem("catalogUUID", this.sharedService.catalogUUID);
            if (!this.sharedService.isEmptyString(this.sharedService.getParameterByName("error"))) {
                this.sharedService.errorStr = decodeURI(this.sharedService.getParameterByName("error"));
            }

            this.load();
        } else if (message.text == 'publish-catalog') {
            this.publishCatalog(this.sharedService.setup, true);
        } else if (message.text == 'launch-published-catalog') {
            this.launchPublishedCatalog();
        }
    }

    async redirectToScalingCatalogIfFlagEnabled() {
        if(window.location.href.indexOf("/session_catalog/#/attendee/") > -1) {
            let result:any = await this.catalogService.findCatalogRedirectToScalingCatalog({"catalogUUID": this.sharedService.catalogUUID}).toPromise();
            if(result.body.redirectTo) {
                let url = document.location.protocol + "//" + document.location.hostname;
                const urlSplit = window.location.href.split('?');
                const queryParams = urlSplit[1] ? '?' + urlSplit[1] : '';
                window.location.href = url + "/catalog/assets/attendee/" + this.sharedService.catalogUUID + queryParams;
            }
        }
    }

   async launchPublishedCatalog() {
        let url = document.location.protocol + "//" + document.location.hostname;

        //Remove PORTAL CUSTOMIZATION DEPENDENCY
        // let result:any = await this.catalogService.findCatalogRedirectToScalingCatalog({"catalogUUID": this.sharedService.setup.uuid}).toPromise();
        
        // if(result.body.redirectTo) { 
        //      window.open(url + "/catalog/assets/attendee/" + this.sharedService.setup.uuid, "_blank");
        // } else {
        //     window.open(url + "/session_catalog/#/attendee/" + this.sharedService.setup.uuid, "_blank");
        // }
        window.open(url + "/catalog/assets/attendee/" + this.sharedService.setup.uuid, "_blank");
    }

    publishCatalog(config, isPublished) {
        if (this.sharedService.publishInProgress) {
            return;
        }
        this.sharedService.publishInProgress = true;
        const pnotify = this.notifyService.getPNotify();
        let temp = pnotify.alert({
            title: "Publish Catalog",
            text: "Please confirm. Are you sure you want to " + (isPublished ? "publish" : "unpublish" ) + " the selected catalog?",
            addClass: "c-pnotify-confirm",
            hide: false,
            textTrusted: true,
            modules: {
                Confirm: {
                    confirm: true,
                    align: "flex-end",
                    buttons: [
                        {
                            text: "Ok",
                            textTrusted: false,
                            addClass: "",
                            primary: true,
                            promptTrigger: true,
                            click: (notice, value) => {
                                let replaceIndex = null;
                                let data = {
                                    id : config.id,
                                    uuid : config.uuid,
                                    isPublished: isPublished
                                }
                                this.catalogService.publishCatalog(data).subscribe((resp) => {
                                    this.sharedService.publishInProgress = false;
                                    this.sharedService.createSaveFilter = false;
                                    this.sharedService.setup = resp["body"]["sessionCatalogSetupDTO"];
                                    this._flashMessagesService.show("Catalog published successfully.", { cssClass: "alert-success" });
                                    this.messageService.sendMessage('update-publish-button');
                                    notice.close();
                                    notice.fire("pnotify.confirm", { notice, value });
                                },
                                (err) => {
                                    this.sharedService.publishInProgress = false;
                                    let errorStr = "There was an error while publishing your catalog, please contact your administrator.";
                                    if (err.error != null) {
                                        errorStr = err.error.errorResponse.errors[0];
                                    }
                                    this._flashMessagesService.show(errorStr, { cssClass: "alert-danger" });
                                    notice.close();
                                    notice.fire("pnotify.confirm", { notice, value });
                                });
                                return true;
                            }
                        },
                        {
                            text: "Cancel",
                            textTrusted: false,
                            addClass: "unsaved-btn--secondary",
                            primary: true,
                            promptTrigger: true,
                            click: (notice, value) => {
                                this.sharedService.publishInProgress = false;
                                notice.close();
                                notice.fire("pnotify.cancel", { notice, value });
                                return false;
                            }
                        }
                    ]
                },
                Buttons: {
                    closer: false,
                    sticker: false
                }
            },
            stack: {
                modal: true
            }
        });
    }


    ngOnInit() {}

    getGainsightAccessKey(): Observable<string> {
        const keyUrl = "/svcs/gainsight/key";
        const httpOptions: object = {
            responseType: 'text'
          };
        this.sharedService.isUpload = true;
        return this.httpClient.get<any>(keyUrl, httpOptions);
    }

    loadScript() {
        let node = document.createElement('script');
        node.type = 'text/javascript';
        node.async = true;
        node.id = 'gainsight';
        node.charset = 'utf-8'
        let hostname = window.location.hostname.split('.').length > 0 ? window.location.hostname.split('.')[0] : window.location.hostname;

        let aprtinsicUserObject = JSON.stringify({
            id: this.sharedService.userInfo.username + '_' + hostname,
 	 	 	email: this.sharedService.userInfo.email,
 	 	 	firstName: this.sharedService.userInfo.name.split(0)[0],
 	 	 	lastName: this.sharedService.userInfo.name.split(0)[1],
 	 	 	signUpDate: this.sharedService.userInfo.dateCreated,
 	 	 	userType: this.sharedService.userInfo.type.name,
            portalCode: hostname
        })

        // account objects
        let aptrinsicAccountObject = JSON.stringify({
            id: this.sharedService.account.name + '_' + this.sharedService.account.code + '_' + hostname,
            name: this.sharedService.account.name,
            platformAcctId: this.sharedService.account.customerId,
            sfdcId: this.sharedService.account.fax
        })
        
        this.getGainsightAccessKey().subscribe(accessKey => {
            if (accessKey && accessKey.length > 0) {
                let temp = document.createTextNode(`(function(n,t,a,e,co){var i="aptrinsic";n[i]=n[i]||function(){
                    (n[i].q=n[i].q||[]).push(arguments)},n[i].p=e;n[i].c=co;
                var r=t.createElement("script");r.async=!0,r.src=a+"?a="+e;
                var c=t.getElementsByTagName("script")[0];c.parentNode.insertBefore(r,c)
                })(window,document,"https://web-sdk./api/aptrinsic.js","${accessKey}")
                
                //passing user and account objects:
                aptrinsic("identify",
                ${aprtinsicUserObject},
                ${aptrinsicAccountObject});
                `);
                node.appendChild(temp);
                document.getElementsByTagName('head')[0].appendChild(node);
            }
        });
    }


    async load() {
        if (this.sharedService.redirectTo == 'attendee') {
            this.catalogService.findByCatalogUUIDES(this.sharedService.catalogUUID).subscribe((resp) => {
                let temp: any = resp.body["sessionCatalogSetupDTO"];
                if (temp == null || temp.id == null) {
                    // TODO : display error that this catalog is not yet puublished.
                    this.catalogService.getLayoutConfig(this.sharedService.catalogUUID).subscribe((resp) => {
                        let layoutConfig:any = resp["body"];
                        if (layoutConfig.messages != null && !(this.sharedService.isEmptyString(layoutConfig.messages.unpublished) 
                            || this.isEmptyHTML(layoutConfig.messages.unpublished))) {
                            this.catalogErrorMessage = layoutConfig.messages.unpublished;
                        } else {
                            this.catalogErrorMessage = "<div>The catalog you are trying to access is not ready.</div>";
                        }
                        this.messageService.sendMessage("catalog_error-catalog", {text : this.catalogErrorMessage});
                    });
                } else {
                    // TODO : check for end date and display error message
                    let today = new Date().getTime();
                    if (temp.endDate != null && temp.endDate <= today) {
                        let layoutConfig = JSON.parse(temp.layoutConfig);
                        if (layoutConfig.messages != null && !(this.sharedService.isEmptyString(layoutConfig.messages.closed) 
                        || this.isEmptyHTML(layoutConfig.messages.closed))) {
                            this.catalogErrorMessage = layoutConfig.messages.closed;
                        } else {
                            this.catalogErrorMessage = "<div>Access to this catalog is closed.</div>";
                        }
                        this.messageService.sendMessage("catalog_error-catalog", {text : this.catalogErrorMessage});
                    } else {
                        this.loadCatalogHelper(resp);
                    }
                }
            });
        } else if (this.sharedService.redirectTo == 'admin' || this.sharedService.redirectTo == 'preview') {
            this.catalogService.findByCatalogUUID(this.sharedService.catalogUUID).subscribe((resp) => {
                if (this.sharedService.redirectTo == 'preview') {
                    let temp = resp.body["sessionCatalogSetupDTO"];
                    if (temp.themeId == 0) {
                        let layoutConfig = JSON.parse(temp.layoutConfig);
                        this.sharedService.selectedTheme = layoutConfig.theme;
                    } else {
                        this.localDataService.getJSON("themes.json").subscribe((data) => {
                            let themes = data;
                            themes.forEach(theme => {
                                if (theme.id == temp.themeId) {
                                    this.sharedService.selectedTheme = theme;
                                }
                            });
                        });
                    }
                }
                this.loadCatalogHelper(resp);
            });
        } else {
            // TODO : display error message
        }
    }

    isEmptyHTML(str) {
        try {
            let ele = document.createElement("p");
            ele.innerHTML = str;
            console.log(jQuery(ele));
            if (ele.firstChild == null || $(ele.firstChild).is(':empty') || ele.firstChild["innerHTML"].trim().length == 0) {
                return 1;
            }
            return 0;
        } catch(err) {
            console.log(err);
            return 1;
        }
    }

    loadCatalogHelper(resp) {
        let temp: any = resp.body["sessionCatalogSetupDTO"];
        this.getSpeakerCustomFields(temp)
        this.getSessionCustomFields(temp)
        this.sharedService.setup = temp;
        this.sharedService.accountUUID = this.sharedService.setup.accountUUID;
        this.sharedService.eventUUID = this.sharedService.setup.eventUUID;
        sessionStorage.setItem("accountUUID", this.sharedService.accountUUID);
        sessionStorage.setItem("eventUUID", this.sharedService.eventUUID);

         if(this.sharedService.isEmptyString(this.sharedService.regUUID)) {
             this.sharedService.regUUID = this.cookieService.get("attendeeUUID_CATALOG_" + this.sharedService.eventUUID);
         }
        sessionStorage.setItem("regUUID_" + this.sharedService.eventUUID, this.sharedService.regUUID);
        this.initializeCatalogConfigHelper(resp);
        this.accountService.getAccountByUUID(this.sharedService.accountUUID).subscribe((resp) => {
            this.helperMethodToLoad(resp);
        });
    }

    loadLoggedinUserInfo(accountId, uuid) {
        this.catalogService.findLoggedInUserInfo(accountId, uuid).subscribe((resp) => {
            this.sharedService.userInfo = resp.body['userDTO'];
            this.loadScript();
        })
    }


    getSessionCustomFields(temp) {
        this.catalogService
        .getCustomFieldList({
            eventId: temp.eventId,
            objectType: "SESSION",
            isCustomFieldUsedInLayout: true
        })
        .subscribe((resp) => {
            this.sharedService.sessionCustomFields = resp.body["data"];
            if (this.sharedService.sessionCustomFields != null) {
                let enumCustomFields = [];
                let fileCustomFields = [];
                this.sharedService.sessionCustomFields.forEach((cf) => {
                    if (
                        cf.questionTypeId == 4 ||
                        cf.questionTypeId == 5 ||
                        cf.questionTypeId == 6 ||
                        cf.questionTypeId == 7
                    ) {
                        enumCustomFields.push(cf);
                    } else if (cf.questionTypeId == 19) {
                        fileCustomFields.push(cf);
                    }
                });
                this.sharedService.sessionEnumCustomFields = enumCustomFields;
                this.sharedService.sessionFileCustomFields = fileCustomFields;
            }
        });
    }

    getSpeakerCustomFields(temp) {
        this.catalogService
        .getCustomFieldList({
            eventId: temp.eventId,
            objectType: "SPEAKER"
        })
        .subscribe((resp) => {
            this.sharedService.speakerCustomFields = resp.body["data"];
            if (this.sharedService.speakerCustomFields != null) {
                let enumCustomFields = [];
                let fileCustomFields = [];
                this.sharedService.speakerCustomFields.forEach((cf) => {
                    if (
                        cf.questionTypeId == 4 ||
                        cf.questionTypeId == 5 ||
                        cf.questionTypeId == 6 ||
                        cf.questionTypeId == 7
                    ) {
                        enumCustomFields.push(cf);
                    } else if (cf.questionTypeId == 19) {
                        fileCustomFields.push(cf);
                    }
                });
                this.sharedService.speakerEnumCustomFields = enumCustomFields;
                this.sharedService.speakerFileCustomFields = fileCustomFields;
            }
        });
    }

    helperMethodToLoad(resp) {
        this.sharedService.account = resp.body["accountDTO"];
        if(window.location.href.includes("admin")) {
            this.loadLoggedinUserInfo(this.sharedService.account.id, 'A0BDF398-0F62-11D5-9CA1-0090271F7663');
        }
        this.eventService.getEventByUUID(this.sharedService.eventUUID).subscribe((resp) => {
            this.sharedService.event = resp.body["eventDTO"];
            this.sharedService.updateCss();
            this.sharedService.updateJson(this.catalogService);
            this.loaded = true;
            this.messageService.sendMessage("update-context", {
                account: this.sharedService.account,
                event: this.sharedService.event,
                catalog: this.sharedService.setup
            });
            this.messageService.sendMessage("update-publish-button", {});
            this.getLoggedInAttendee();
        });
    }

    initializeCatalogConfigHelper(resp) {
        let temp: any = resp.body["sessionCatalogSetupDTO"];
        this.sharedService.catalogLayoutConfig = JSON.parse(temp.layoutConfig);
        if (temp.setupConfigs != null) {
            temp.setupConfigs.forEach((element) => {
                this.sharedService.configs[element.configType] = element;
            });
            temp.setupConfigs = null;
        }
        this.sharedService.setup = temp;
    }

    getLoggedInAttendee() {
        let regUUID = this.sharedService.regUUID;
        if (!this.sharedService.isEmptyString(regUUID)) {
            let regCookiee = this.cookieService.get("REGISTRATION_SESS_UUID_CATALOG_" + this.sharedService.eventUUID);
            if (regCookiee != null) {
                this.attendeeSessionService.getRegistrationByUUID().subscribe((resp) => {
                    let reg = resp.body["registrationDTO"];
                    if (reg.id != null && reg.eventId == this.sharedService.event.id && reg.isActive) {
                        this.sharedService.loggedInAttendee = resp.body["registrationDTO"];
                        sessionStorage.setItem(
                            "loggedInAttendee_" + this.sharedService.eventUUID,
                            JSON.stringify(this.sharedService.loggedInAttendee)
                        );
                        sessionStorage.setItem(
                            "regUUID_" + this.sharedService.eventUUID,
                            this.sharedService.loggedInAttendee.uuid
                        );
                        this.messageService.sendMessage("loggedIn");
                        this.attendeeSessionService.getSessionApiOnLogin();
                        this.popupService.hidePopup();
                    } else {
                        this.messageService.sendMessage("attendee-deleted");
                    }
                });
            } else {
                let loginModal = { regUUID: this.sharedService.regUUID, eventUUID: this.sharedService.eventUUID };
                this.sharedService.loginWithReUUID = true;
                this.attendeeSessionService.login(loginModal).subscribe(
                    (resp) => {
                        this.sharedService.loggedInAttendee = resp.body["registrationDTO"];
                        sessionStorage.setItem(
                            "loggedInAttendee_" + this.sharedService.eventUUID,
                            JSON.stringify(this.sharedService.loggedInAttendee)
                        );
                        sessionStorage.setItem(
                            "regUUID_" + this.sharedService.eventUUID,
                            this.sharedService.loggedInAttendee.uuid
                        );
                        this.attendeeSessionService.getSessionApiOnLogin();
                        this.messageService.sendMessage("attendee-login");
                        this.popupService.hidePopup();

                        this.attendeeSessionService
                            .getCartData(this.sharedService.loggedInAttendee.uuid)
                            .subscribe((resp) => {
                                this.sharedService.cartData = resp.body;
                            });
                    },
                    (err) => {
                        var message = "";
                        if (err.error.errorResponse != null && err.error.errorResponse.errors != null) {
                            err.error.errorResponse.errors.forEach((element) => {
                                message += element + "\n";
                            });
                        }

                        this._flashMessagesService.show(message, {
                            cssClass: "alert-danger"
                        });
                    }
                );
            }
        }
    }
}
